import { Flex, Logo } from "@wearewqa/wqa-design-system";
import React from "react";
import styled, { css } from "styled-components";
import { Container } from "../Container";

// interface HeaderProps {}

const StyledHeader = styled.header(
  ({ theme: { color } }) => css`
    border-bottom: 1px solid ${color.border.base};
    padding: 20px 0;
    margin-bottom: 40px;
  `
);

export const Header: React.FC = () => {
  return (
    <StyledHeader>
      <Container>
        <Flex>
          <Logo
            size={{
              width: 70,
            }}
          />
        </Flex>
      </Container>
    </StyledHeader>
  );
};
